export default __webpack_public_path__ + "static/pro-pic-71fb1740edb7b96d79fe7bc8b42ef7d4.png";